import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=2b5a25df&scoped=true&lang=pug&"
import script from "./BaseTabs.vue?vue&type=script&lang=js&"
export * from "./BaseTabs.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&id=2b5a25df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a25df",
  null
  
)

export default component.exports